module.exports = __webpack_public_path__ + "static/media/opt-in-bar.855b5077.svg";